module.exports = __webpack_public_path__ + "static/media/tools-eraser.49ce2cba.svg";